import React, { ReactNode } from 'react';
import { HeadingText, HeadingTextProps } from '../atoms/HeadingText';
import cn from 'classnames';

interface TitleProps {
	children: ReactNode;
	className?: string;
	tag?: HeadingTextProps['tag'];
	size?: HeadingTextProps['size'];
}

const Title = (props: TitleProps) => {
	const { children, className, tag = 'h2', size = 'h2' } = props;
	return (
		<HeadingText
			tag={tag}
			size={size}
			className={cn({ 'mb-4 lg:mb-10': !className }, className)}
			balanced
		>
			{children}
		</HeadingText>
	);
};

export default Title;
